import commonApi from './CommonApi.js';

var qs = require('query-string');

export default {
	
	register: async (viewModel) => {
		return await commonApi().post('/v1/registration/register', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}